import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import './styles/light-theme.css';
import ProjectPage from './pages/ProjectPage';
import AdminPanel from './pages/AdminPanel';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import UXPortfolio from './components/UXPortfolio';
import PhotoPortfolio from './components/PhotoPortfolio';
import BlogSection from './components/BlogSection';
import { ContactSection, Footer } from './components/Contact';

// Main Portfolio Page - Single Page with Toggle
const PortfolioPage = () => {
  const [mode, setMode] = useState('ux');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleModeChange = (newMode) => {
    setMode(newMode);
    // Smooth scroll to top when switching modes
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div data-testid="portfolio-page" style={{ background: 'var(--bg-primary)', minHeight: '100vh' }}>
      <Navigation 
        mode={mode} 
        onModeChange={handleModeChange} 
        scrolled={scrolled}
      />
      <main>
        <HeroSection mode={mode} />
        
        {mode === 'ux' ? (
          <>
            <UXPortfolio />
            <BlogSection />
          </>
        ) : (
          <PhotoPortfolio />
        )}
        
        <ContactSection mode={mode} />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PortfolioPage />} />
          <Route path="/project/:slug" element={<ProjectPage />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
